import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBTable, MDBTableBody, MDBTableHead, MDBIcon } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../../api';

export default class Modalsentpassforex extends Component {
    constructor(props) {
        super(props);
        this.state = {
          modal: false,

          inside:"",
          faculty:"",
          Expert:[],
          idExpert:"",
          send_comment1:"",
          success:"",
          filecomment1:null,

          id_send:"",
          name_article:"",
          fileclosenameword:null,
          fileclosenamepdf:null,


          id_comment:"",
          id_bn:"",
          show:"",
          comment_admin:"",
          Expertmaparticle:[],
          Expertmaparticle2:null,
          

        }

this.handleChange = this.handleChange.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
this.getExpertmaparticle = this.getExpertmaparticle.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
}


handleChange2(event) {    this.setState({fileclosenameword: event.target.files[0]});  }
handleChange3(event) {    this.setState({fileclosenamepdf: event.target.files[0]});  }

toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  //this.props.selectatf();
}

handleChangetype(event) {    this.setState({comment_admin: event.target.value});  }


 componentDidMount() {
      const { id_send } = this.props.id_send
    //  console.log(this.props.id_send);
                    this.setState({   id_send:this.props.id_send,
                         name_article:this.props.name_article,
                    })
                    this.getExpertmaparticle();

  }

  getExpertmaparticle() {
    setTimeout(() => {
      //ภายใน
      api.get('registercon/selectexpertforarticle/'+this.props.id_send)
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expertmaparticle: res.data})
    
      
        const finalArr = [];
        const objs = res.data.map((val) => {
            finalArr.push(Object.assign({}, val));
        });
        console.log(finalArr)
        this.setState({ Expertmaparticle2: finalArr})


      }) 

    }, 400);

}

  handleChange(event) {    this.setState({show: event.target.value});  }



  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

    const check = this.state.Expertmaparticle;
    const fileclosenameword1 = this.state.fileclosenameword;
    const fileclosenamepdf1 = this.state.fileclosenamepdf;

    console.log(fileclosenameword1)
    console.log(fileclosenamepdf1)
   setTimeout(() => {

  //  for (let index = 0; index < this.state.Expertmaparticle.length; index++) {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_send", this.props.id_send);
     // datafrm.append("check",JSON.stringify(check));
     // datafrm.append("id_expertex", this.state.Expertmaparticle[index].id_expert);
    //   datafrm.append("fileclosenameword", this.state.fileclosenameword);
    //   datafrm.append("fileclosenamepdf", this.state.fileclosenamepdf);
    //   datafrm.append("date_sentexpert", dates);
     

      api.post("registercon/updatestatuspasssuccessall",datafrm,{
    //  api.post("registercon/InsertArticlemapexpert",{
    headers: {
        'content-type': 'multipart/form-data'
    },
    //    check: check,
    //    id_sendarticle:this.state.id_send,
    //    fileclosenameword: fileclosenameword1,
    //    fileclosenamepdf: fileclosenamepdf1,
    //    date_sentexpert:dates,


   })

   .then(res => {

    if (res.data = '200' ) {
                        Swal.fire({
                        title: 'บันทึกบทความเสร็จสมบูรณ์',
                        text: "Suggestion saved successfully",
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.props.updateat()
                            this.toggle()
                        }
                    })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })

//}

}, 1000);


  }

  

    render() {

  console.log(this.state.Expertmaparticle) 
  console.log(this.state.fileclosenameword) 
  console.log(this.state.fileclosenamepdf) 
        
        return (
            <MDBContainer>

                    {/* <MDBTable bordered responsive small>
                            <MDBTableHead color="blue-grey lighten-3" textWhite>
                                <tr>
                                <th>ลำดับ</th>
                                <th>ชื่อผู้ทรงคุณวุฒิ</th>
                                <th>สังกัด</th>
                                <th>ความเชียวชาญ</th>
                                <th>เบอร์โทร</th>
                                </tr>
                            </MDBTableHead>

                            <MDBTableBody>
                            {this.state.Expertmaparticle.map((Expertmaparticle,index )  => 
                                <tr>
                                <td>{index+1}</td>
                                <td>{Expertmaparticle.name_expert}</td>
                                <td>{Expertmaparticle.affiliation_expert}</td>
                                <td>{Expertmaparticle.expertise_expert}</td>
                                <td>{Expertmaparticle.tel_expert}</td>
                                </tr>
                            )}
                            </MDBTableBody>
                    </MDBTable> */}


           <div className='text-center'>

            <MDBBtn color="dark-green" onClick={this.toggle} size='sm' >ส่งเข้าสู่การนำเสนอ</MDBBtn>
                </div> 

                <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
                <MDBModalHeader toggle={this.toggle}>ส่งเข้าสู้การนำเสนอ </MDBModalHeader>
                <MDBModalBody>
                    <div className='text-center'>
                    <p>ชื่อบทความ : {this.props.name_article}</p>
                    {/* <p className='red-text text-center'>ขั้นตอนนี้ต้องปิดชื่อบทความ</p> */}
                    <MDBBtn color="dark-green" onClick={this.handleSubmit} size='lg'>ยืนยันบทความเสร็จสมบูรณ์</MDBBtn> 
                                

                    </div>
                </MDBModalBody>
                <MDBModalFooter>
                    {/* <MDBBtn color="primary" onClick={this.handleSubmit} >ยืนยัน</MDBBtn> */}
                    <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                
                </MDBModalFooter>
                </MDBModal>
            </MDBContainer>
          
        )
    }
}
